import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const Status = ({dbBook, soldBook}) => {

  const navigate = useNavigate()

  const trackingLink = (code) => {
    if (soldBook.carrier_code === 'dao') {
      window.open(`https://dao.as/find-din-pakke/?stregkode=${code}`, '_blank').focus()
    } else if (soldBook.carrier_code === 'pdk') {
      window.open(`https://portal.postnord.com/tracking/`, '_blank').focus()
    } else if (soldBook.carrier_code === 'gls') {
      window.open(`https://gls-group.com/DK/da/find-pakke`, '_blank').focus()
    } else if (soldBook.carrier_code === 'bring') {
      window.open(`https://tracking.bring.com/tracking/${code}`, '_blank').focus()
    }
  }
  
  return (
    <div className="buyerDetails flex flex-col flex-wrap gap-5 shadow-lg p-10 w-full box-border">
      <h2 className="text-sm md:text-base font-bold">Oversigt</h2>
      <div className="flex flex-col gap-y-8 justify-between h-full flex-[1]">
        <div className="gap-y-8 flex flex-col">
          <div className="w-full">
            <label for="name" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Status</label>
            <h2 className="text-sm">
              {(dbBook.status === 1) ? "Afhentes af køber" : (dbBook.status === 2) ? "Mangler afsendelse" : (dbBook.status === 3) ? "Afsendt" : (dbBook.status === 4) ? "Leveret" : (dbBook.status === 5 || dbBook.status === 6) ? "Refunderingsanmodning" : "Afsluttet"}
            </h2>
          </div>
          {(dbBook.status === 2 || dbBook.status === 3 || dbBook.status === 4) ?
            <div className="w-full">
              <label for="name" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Sporingsnummer</label>
              <h2 className="text-sm cursor-pointer hover:text-emerald-600 transition-[] underline w-fit" onClick={() => trackingLink(soldBook.pkg_no)}>
                {soldBook.pkg_no}
              </h2>
            </div>
          :
            ""
          }
        </div>
        <div className="py-2 px-5 text-white w-fit cursor-pointer transition bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100" onClick={() => navigate(`/indbakke?book=${dbBook._id}`)}>Kontakt køber</div>
      </div>
    </div>
    
  )
}